<template>
	<div>
        <div class="row title-container">
            <div class="col-xs-12 col-lg-12" style="padding: 0px 15px;">
                <div class="row">
                    <div class="col-lg-6">
                        <h3>
                            <i class="fas fa-fw fa-box"></i> Nº da entrega: <span style="font-weight: lighter;"><code>{{ current.document_number }}</code></span>
                        </h3>
                    </div>
                    <div class="col-lg-6">
                        <h4 style="text-align: right; line-height: 23px;"><i class="fas fa-fw fa-calendar-alt"></i> Data de entrega: <span style="font-weight: lighter;">{{ current.date.split("-").reverse().join("/") }}</span></h4>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-lg-12" style="padding: 15px; border-top: 1px solid #ddd; background-color: #eee;">
                <div class="row">
                    <div class="col-lg-3 capitalized" title="Cliente">
                        <div class="row">
                            <div class="col-xs-12 col-lg-12" style="font-size: 20px; text-align: center; margin-bottom: 10px;">
                                <i class="fas fa-fw fa-building"></i>
                            </div>
                            <div class="col-xs-12 col-lg-12" style="font-size: 12px; font-weight: bold; text-align: center;">
                                {{ current.customer_name ? current.customer_name.toLowerCase() : "" }}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3" title="Veículo">
                        <div class="row">
                            <div class="col-xs-12 col-lg-12" style="font-size: 20px; text-align: center; margin-bottom: 10px;">
                                <i class="fas fa-fw fa-truck"></i>
                            </div>
                            <div class="col-xs-12 col-lg-12" style="font-size: 12px; font-weight: bold; text-align: center;">
                                {{ current.license_plate ? current.license_plate : "Não definido" }}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 capitalized" title="Motorista">
                        <div class="row">
                            <div class="col-xs-12 col-lg-12" style="font-size: 20px; text-align: center; margin-bottom: 10px;">
                                <i class="fas fa-fw fa-address-card"></i>
                            </div>
                            <div class="col-xs-12 col-lg-12" style="font-size: 12px; font-weight: bold; text-align: center;">
                                {{ current.driver_name ? current.driver_name.toLowerCase() : "Não definido" }}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3" title="Carga">
                        <div class="row">
                            <div class="col-xs-12 col-lg-12" style="font-size: 20px; text-align: center; margin-bottom: 10px;">
                                <i class="fas fa-fw fa-boxes"></i>
                            </div>
                            <div class="col-xs-12 col-lg-12" style="font-size: 12px; font-weight: bold; text-align: center;">
                                {{ current.cargo ? current.cargo : "Não definida" }} {{ current.sequence ? "(nº "+ current.sequence  +")" : "" }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-lg-12">
                <div class="col-xs-12 col-lg-12 container-collapse">
                    <div class="row">
                        <div class="col-xs-12 col-lg-12" @click="show_detail = !show_detail">
                            <div class="container-collapse-header">
                                <span><b>Informações gerais</b></span>
                                <span class="collapse-header-arrow" v-if="show_detail"><i class="fa fa-chevron-up"></i></span>
                                <span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
                            </div>
                        </div>
                        <div v-show="show_detail" class="col-lg-12 container-collapse-body">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td><b>Emissor</b></td>
                                        <td class="capitalized">{{ current.company_name.toLowerCase() }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Documento</b></td>
                                        <td>{{ getDocumentFormatted(current.company_document) }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Tipo</b></td>
                                        <td>{{ getType(current.type) }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Número</b></td>
                                        <td>{{ current.document_number }}</td>
                                    </tr>
                                    <tr v-if="current.code">
                                        <td><b>Chave de fato</b></td>
                                        <td>{{ current.code }}</td>
                                    </tr>
                                    <tr v-if="current.code_stock">
                                        <td><b>Local de estoque</b></td>
                                        <td>{{ current.distribution_center_name }}</td>
                                    </tr>
                                    <tr v-if="current.code_moviment_type">
                                        <td><b>Tipo de movimento</b></td>
                                        <td>{{ current.code_moviment_type }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Data de cadastro</b></td>
                                        <td>{{ getDatetimeFormatted(current.created_at) }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Data de entrega</b></td>
                                        <td>{{ getDateFormatted(current.date) }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Peso</b></td>
                                        <td>{{ getWeight(current.weight) }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Quantidade total</b></td>
                                        <td>{{ current.quantity }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Pagamento</b></td>
                                        <td>
                                            <ul class="list-unstyled">
                                                <li v-for="(pag, idx) in current.payment" :key="idx"><b>{{ getPaymentMethod(pag.type) }}:</b> {{ getMoney(pag.value) }}</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>Valor total</b></td>
                                        <td>
                                            <span v-if="current.payment">
                                                R$ {{ current.payment.reduce((t, p) => t + parseFloat(p.value), 0).toFixed(2).replace(".", ",") }}
                                            </span>
                                            <span v-else>
                                                N/A
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-lg-12">
                <div class="col-xs-12 col-lg-12 container-collapse">
                    <div class="row">
                        <div class="col-xs-12 col-lg-12" @click="show_customer = !show_customer">
                            <div class="container-collapse-header">
                                <span><b>Informações do destinatário</b></span>
                                <span class="collapse-header-arrow" v-if="show_customer"><i class="fa fa-chevron-up"></i></span>
                                <span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
                            </div>
                        </div>
                        <div v-show="show_customer" class="col-lg-12 container-collapse-body">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td><b>Cliente</b></td>
                                        <td class="capitalized">{{ current.customer_name.toLowerCase() }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Documento</b></td>
                                        <td>{{ getDocumentFormatted(current.customer_document) }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>CEP</b></td>
                                        <td>{{ getPostalCodeFormatted(current.postal_code) }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Endereço</b></td>
                                        <td class="capitalized">{{ current.street.toLowerCase() }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Número</b></td>
                                        <td class="capitalized">{{ current.number.toLowerCase() }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Complemento</b></td>
                                        <td class="capitalized">{{ current.complement ? current.complement.toLowerCase() : "-" }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Cidade</b></td>
                                        <td class="capitalized">{{ current.city.toLowerCase() }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Estado</b></td>
                                        <td>{{ current.uf }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Pais</b></td>
                                        <td class="capitalized">{{ current.country.toLowerCase() }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-lg-12">
                <div class="col-xs-12 col-lg-12 container-collapse">
                    <div class="row">
                        <div class="col-xs-12 col-lg-12" @click="show_driver = !show_driver">
                            <div class="container-collapse-header">
                                <span><b>Informações de transporte</b></span>
                                <span class="collapse-header-arrow" v-if="show_driver"><i class="fa fa-chevron-up"></i></span>
                                <span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
                            </div>
                        </div>
                        <div v-show="show_driver" class="col-lg-12 container-collapse-body">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td><b>Placa do veículo</b></td>
                                        <td>{{ current.license_plate ? current.license_plate : "Não definido"}}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Motorista</b></td>
                                        <td class="capitalized">{{ current.driver_name ? current.driver_name.toLowerCase() : "Não definido"}}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Documento</b></td>
                                        <td>{{ current.driver_document ? getDocumentFormatted(current.driver_document) : "Não definido" }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Carga</b></td>
                                        <td>{{ current.cargo ? current.cargo : "Não definida" }}</td>
                                    </tr>
                                    <tr v-if="client_atak">
                                        <td><b>Carga externa</b></td>
                                        <td>{{ current.cargo_external ? current.cargo_external : "Não definida" }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Sequência</b></td>
                                        <td>{{ current.sequence ? current.sequence : "Não definida" }}</td>
                                    </tr>
                                    <tr v-if="client_atak">
                                        <td><b>Código do estoque</b></td>
                                        <td>{{ current.code_stock ? current.code_stock : "Não definido" }}</td>
                                    </tr>
                                    <tr v-if="client_atak">
                                        <td><b>Código do percurso</b></td>
                                        <td>{{ current.code_course ? current.code_course : "Não definido" }}</td>
                                    </tr>
                                    <tr v-if="client_atak">
                                        <td><b>Percurso</b></td>
                                        <td>{{ current.course ? current.course : "Não definido" }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Temperatura</b></td>
                                        <td>{{ getTemperature(current.temperature_ambient, current.temperature_chilled, current.temperature_frozen) }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Possui osso</b></td>
                                        <td>{{ getBone(current.with_bone, current.without_bone) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="false" class="col-lg-12" style="background-color: #eee;">
            <div class="row">
                <div class="col-lg-5" style="padding: 10px 0px 10px 10px;">
                    <div class="col-lg-12" style="border: 1px solid #ddd; padding: 20px; border-radius: 5px; background-color: #fff;">
                        <h4 style="margin-top: 0px;"><i class="fas fa-fw fa-home"></i> Endereço de entrega</h4>
                        <p class="capitalized" style="margin: 0px;">
                            <b>{{ current.customer_name.toLowerCase() }}</b>, <br/>
                            {{ current.street.toLowerCase() }}, <br/>
                            {{ current.number.toLowerCase() }} ({{ current.complement.toLowerCase() }}), {{ current.neighborhood.toLowerCase() }},  {{ current.city.toLowerCase() }} - {{ current.uf }}, <br/>
                            {{ current.postal_code }}</p>
                    </div>
                </div>
                <div class="col-lg-4" style="padding: 10px 0px 10px 10px;">
                    <div class="col-lg-12" style="border: 1px solid #ddd; padding: 20px; border-radius: 5px; background-color: #fff;">
                        <h4 style="margin-top: 0px;"><i class="fas fa-fw fa-truck"></i> Transporte</h4>
                        <p class="capitalized"></p>
                    </div>
                </div>
                <div class="col-lg-3" style="padding: 10px 10px 10px 10px;">
                    <div class="col-lg-12" style="border: 1px solid #ddd; padding: 20px; border-radius: 5px; background-color: #fff;">
                        <h4 style="margin-top: 0px;"><i class="fas fa-fw fa-money-bill"></i> Pagamento</h4>
                        <p class="capitalized"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-lg-12">
                <div class="col-xs-12 col-lg-12 container-collapse">
                    <div class="row">
                        <div class="col-xs-12 col-lg-12" @click="show_timeline = !show_timeline">
                            <div class="container-collapse-header">
                                <span><b>Linha do tempo</b></span>
                                <span class="collapse-header-arrow" v-if="show_timeline"><i class="fa fa-chevron-up"></i></span>
                                <span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
                            </div>
                        </div>
                        <div v-show="show_timeline" class="col-lg-12 container-collapse-body">
                            <div class="row timeline-container">
                                <div class="col-xs-2 timeline timeline-active">
                                    <div class="row timeline-step-first timeline-step-first-active">
                                        <div class="col-lg-12 timeline-step-head">
                                            <h1><span><i class="fas fa-fw fa-check-circle"></i></span></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-icon">
                                            <h1><i class="fa fa-fw  fa-pallet"></i></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-label">
                                            <b>Aguardando</b>
                                        </div>
                                        <div class="col-lg-12 timeline-step-datetime">
                                            {{ getDatetimeFormatted(current.created_at) }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-2 timeline" :class="((current.status == 'in_progress') || (current.status == 'finished') || (current.status == 'failed')) || current.delivery_start ? 'timeline-active' : ''">
                                    <div class="row timeline-step" :class="((current.status == 'in_progress') || (current.status == 'finished') || (current.status == 'failed')) || current.delivery_start ? 'timeline-step-active' : ''">
                                        <div class="col-lg-12 timeline-step-head">
                                            <h1><span><i :class="current.delivery_start ? 'fas fa-fw fa-check-circle' : 'far fa-fw fa-circle'"></i></span></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-icon">
                                            <h1><i class="fas fa-fw fa-truck"></i></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-label">
                                            <b>A caminho</b>
                                        </div>
                                        <div class="col-lg-12 timeline-step-datetime">
                                            {{ getDatetimeFormatted(current.delivery_start) }}
                                        </div>
                                    </div>
                                </div>
                                <div v-if="current.delivery_pause" class="col-xs-2 timeline timeline-active">
                                    <div class="row timeline-step timeline-step-active">
                                        <div class="col-lg-12 timeline-step-head">
                                            <h1><span><i :class="current.delivery_pause ? 'fas fa-fw fa-check-circle' : 'far fa-fw fa-circle'"></i></span></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-icon">
                                            <h1><i class="fas fa-fw fa-pause"></i></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-label">
                                            <b>Pausado</b>
                                        </div>
                                        <div class="col-lg-12 timeline-step-datetime">
                                            {{ getDatetimeFormatted(current.delivery_pause) }}
                                        </div>
                                    </div>
                                </div>
                                <div v-if="current.delivery_pause" class="col-xs-2 timeline" :class="current.delivery_restart ? 'timeline-active' : ''">
                                    <div class="row timeline-step" :class="current.delivery_restart ? 'timeline-step-active' : ''">
                                        <div class="col-lg-12 timeline-step-head">
                                            <h1><span><i :class="current.delivery_restart ? 'fas fa-fw fa-check-circle' : 'far fa-fw fa-circle'"></i></span></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-icon">
                                            <h1><i class="fas fa-fw fa-sync"></i></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-label">
                                            <b>Reiniciado</b>
                                        </div>
                                        <div class="col-lg-12 timeline-step-datetime">
                                            {{ getDatetimeFormatted(current.delivery_restart) }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-2 timeline" :class="((current.status == 'finished') || (current.status == 'failed')) || current.checkin_date ? 'timeline-active' : ''">
                                    <div class="row timeline-step" :class="((current.status == 'finished') || (current.status == 'failed')) || current.checkin_date ? 'timeline-step-active' : ''">
                                        <div class="col-lg-12 timeline-step-head">
                                            <h1><span><i :class="current.checkin_date ? 'fas fa-fw fa-check-circle' : 'far fa-fw fa-circle'"></i></span></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-icon">
                                            <h1><i class="fas fa-fw fa-people-carry"></i></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-label">
                                            <b>Entregando</b>
                                        </div>
                                        <div class="col-lg-12 timeline-step-datetime">
                                            {{ getDatetimeFormatted(current.checkin_date) }}
                                        </div>
                                    </div>
                                </div>
                                <div v-if="current.status == 'failed' && current.delivery_end" class="col-xs-2 timeline" :class="current.delivery_end ? 'timeline-active' : ''">
                                    <div class="row timeline-step" :class="current.delivery_end ? 'timeline-step-active' : ''">
                                        <div class="col-lg-12 timeline-step-head">
                                            <h1><span><i :class="current.delivery_end ? 'fas fa-fw fa-check-circle' : 'far fa-fw fa-circle'"></i></span></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-icon">
                                            <h1><i class="fas fa-fw fa-times"></i></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-label">
                                            <b>Não entregue</b>
                                        </div>
                                        <div class="col-lg-12 timeline-step-datetime">
                                            {{ getDatetimeFormatted(current.delivery_end) }}
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="col-xs-2 timeline" :class="(current.status == 'finished') || current.delivery_end ? 'timeline-active' : ''">
                                    <div class="row timeline-step" :class="(current.status == 'finished') || current.delivery_end ? 'timeline-step-active' : ''">
                                        <div class="col-lg-12 timeline-step-head">
                                            <h1><span><i :class="current.delivery_end ? 'fas fa-fw fa-check-circle' : 'far fa-fw fa-circle'"></i></span></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-icon">
                                            <h1><i class="fas fa-fw fa-check"></i></h1>
                                        </div>
                                        <div class="col-lg-12 timeline-step-label">
                                            <b>Finalizado</b>
                                        </div>
                                        <div class="col-lg-12 timeline-step-datetime">
                                            {{ getDatetimeFormatted(current.delivery_end) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td><b>Status atual</b></td>
                                        <td><span :style="'color: ' + getStatusColor(current.status, current.checkin_date)"><i class="fas fa-fw fa-circle"></i></span>{{ getStatus(current.status, current.checkin_date) }}</td>
                                    </tr>
                                    <tr v-if="current.estimated_start_time && !current.delivery_start">
                                        <td><b>Estimativa início</b></td>
                                        <td>{{ getDate() + " " + current.estimated_start_time }}</td>
                                    </tr>
                                    <tr v-else>
                                        <td><b>Início</b></td>
                                        <td>{{ getDatetimeFormatted(current.delivery_start) }}</td>
                                    </tr>
                                    <tr v-if="current.delivery_pause">
                                        <td><b>Pausa</b></td>
                                        <td>{{ getDatetimeFormatted(current.delivery_pause) }}</td>
                                    </tr>
                                    <tr v-if="current.delivery_pause">
                                        <td><b>Reinício</b></td>
                                        <td>{{ getDatetimeFormatted(current.delivery_restart) }}</td>
                                    </tr>
                                    <tr v-if="current.checkin_date || current.delivery_end">
                                        <td><b>Check-in</b></td>
                                        <td>{{ getDatetimeFormatted(current.checkin_date) }}</td>
                                    </tr>
                                    <tr v-if="current.estimated_end_time && !current.delivery_end">
                                        <td><b>Estimativa finalização</b></td>
                                        <td>{{ getDate() + " " + current.estimated_end_time }}</td>
                                    </tr>
                                    <tr v-else>
                                        <td><b>Finalização</b></td>
                                        <td>{{ getDatetimeFormatted(current.delivery_end) }}</td>
                                    </tr>
                                    <tr v-if="current.delivery_info">
                                        <td><b>Observações</b></td>
                                        <td>{{ current.delivery_info }}</td>
                                    </tr>
                                    <tr v-if="(current.status == 'in_progress') || ((current.status == 'in_progress') && !current.checkin_date)">
                                        <td><b>Link de acompanhamento</b></td>
                                        <td>
                                            <span style="position: relative;padding-left: 40px;">
                                                <a class="button-share" href="#" @click.prevent.stop="copy(current.share);" ><i class="fa fa-copy"></i></a> 
                                                {{ current.share }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="(current.status == 'in_progress') || ((current.status == 'in_progress') && !current.checkin_date)">
                                        <td colspan="2" style="text-align: center;"><b>Rota estimada</b></td>
                                    </tr>
                                    <tr v-if="(current.status == 'in_progress') || ((current.status == 'in_progress') && !current.checkin_date)">
                                        <td class="td-map" colspan="2">
                                            <div ref="map" class="checkin-map"></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import L from "leaflet";
import $ from "jquery";
import "leaflet/dist/leaflet.css";

import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.js";

const attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
const osmUrl = "http://{s}.tile.osm.org/{z}/{x}/{y}.png";
const status = {
	no_delivery: {
		color: "#aaa",
		status: "Nenhuma entrega",
	},
	waiting: {
		color: "#555",
		status: "Aguardando",
	},
	in_progress: {
		color: "#005ef7",
		status: "A caminho",
	},
	check_in: {
		color: "#ffb300",
		status: "Entregando",
	},
	finished: {
		color: "#008000",
		status: "Finalizado",
	},
	failed: {
		color: "#ff0000",
		status: "Não entregue",
	},
	untracked: {
		color: "#eee",
		status: "Desvinculada",
	},
};

export default {
	name: "DeliveryDetail",
	
	props: {
		current: {
			type: Object,
			require: true,
		},
	},

	data: function() {
		return {
			map: null,

			// Define o servidor de roteirização
            router: new L.Routing.OSRMv1({
                serviceUrl: this.$api.config.B2B_ROOT_URL_API_TRACER,
                profile: 'driving',
                timeout: 30000,
                routingOptions: {
                    alternatives: false,
                    steps: true
                },
                useHints: false,
                language: 'pt-BR'
            }),

			center: ["-23.4161243","-51.9246975"],
            zoom: 12,
			control: null,

			show_detail: false,
			show_customer: false,
			show_driver: false,
			show_timeline: true,

            client_atak: this.$api.user.company_client_atak,
		};
	},

	mounted: async function() {
		if((this.current.status == 'in_progress') || ((this.current.status == 'in_progress') && !this.current.checkin_date)) {
			// Inicia o mapa
			this.initializeMap();
			// Cria a rota
			this.createRoute();
		}
	},

	created: function() {
		if((this.current.status == 'in_progress') || ((this.current.status == 'in_progress') && !this.current.checkin_date)) {
			this.hideControlDivs(true);
		}
    },

	methods: {
		/**
		 * Gera o mapa com os marcadores no modal
		 **/
        initializeMap: function() {
            // Cria o mapa
            let map = new L.map(
                this.$refs.map, {
                    center: [this.center[0], this.center[1]],
                    zoom: this.zoom,
                    zoomControl: false
                }
            );
            
            // Define a posição do zoom control
            let zoomControl = new L.control.zoom({
                position: 'topright'
            });
            zoomControl.addTo(map);

            let titleLayer = new L.tileLayer(
                osmUrl, {
                    attribution: attribution
                }
            );
            titleLayer.addTo(map);
			
			// Define o objeto do mapa
            this.map = map;
        },

		/**
         * Processa uma rota e exibe no Mapa
         **/ 
        createRoute: function() {
            // Define as funções localmente
            let createStartMarker = this.createStartMarker;
            let createDeliveryMarker = this.createDeliveryMarker;
            let notification = this.$notification;

            // Determina os pontos de parada
            let waypoints = this.processWaypoints();

            // Define o plan do control
            let plan = new L.Routing.plan(waypoints, {
                addWaypoints: false,
                draggableWaypoints: false,
                routeWhileDragging: false,
                createMarker: function (index, waypoint) {
					// Verifica o ponto atual
					if (index == 0) {
						// Retorna o marcador
						return createStartMarker(waypoint);
					} else {
						// Retorna o marcador
						return createDeliveryMarker(waypoint);
					}
                },
            });
            
            // Define o control da rota
            let control = new L.Routing.control({
                waypoints: waypoints,
                router: this.router,
                plan: plan,
                fitSelectedRoutes: "smart",
                routeLine: function(route) {
                    // Define a linha da rota
                    let line = new L.Routing.line(route, {
                        addWaypoints: false,
                        styles: [
                            {color: "blacks", opacity: 0.15, weight: 9},
                            {color: "white", opacity: 0.8, weight: 6},
                            {color: "#669df6", opacity: 1, weight: 4}
                        ]
                    });

                    // Retorna a linha
                    return line;
                },
                units: "metric",
                showAlternatives: false,
                useZoomParameter: false,
                show: false,
                waypointMode: "snap",
            }).on("routingerror", function(e) {
                console.log(e);
                // Exibe mensagem de erro ao não encontrar rota
                notification.error("Não foi possível encontrar uma rota estimada.");
            });
			
			// Adiciona ao mapa
			control.addTo(this.map);

			// Armazena o controle
			this.control = control;
			
			// Atualiza o zom e center do map
			this.map.setView(waypoints[0], 16, {
                animation: true
            });
        },

		/**
         * Processa os pontos da rota
         * @return {array} lista de pontos
         **/ 
        processWaypoints: function() {
			// Inicia lista de pontos
            let waypoints = [];
            
            // Transforma as latitudes e longitudes
			if (this.current.checkin_location) {
				let latLng1 = this.current.checkin_location.split(",");
				waypoints.push(L.latLng(latLng1[0], latLng1[1]));
			} else if(this.current.delivery_location) {
				let latLng1 = this.current.delivery_location.split(",");
				waypoints.push(L.latLng(latLng1[0], latLng1[1]));
			}
			
			if (this.current.coordinates) {
				let latLng2 = this.current.coordinates.split(",");
				waypoints.push(L.latLng(latLng2[0], latLng2[1]));
			}
            
            // Retorna a lista de pontos
            return waypoints;
        },
		
		/**
		 * Adiciona o marcador de início
		 **/
        createStartMarker: function(waypoint) {
			// Define as variáveis necessárias
			let textDriverNameAux = "";
			let date = "";
			let hour = "";
			
			// Define o nome do motorista
			if(this.current.driver_name) {
				textDriverNameAux = '<p class="marker capitalized"><b>' +  this.current.driver_name + '</b></p>';
			}

			// Define data e hora do início
			if(this.current.checkin_date) {
				date = this.getDateFormatted(this.current.checkin_date.split(" ")[0]);
				date = '<p class="marker"><i class="fa fa-fw fa-calendar-alt"></i> Data: ' +  date + '</p>';

				hour = this.current.checkin_date.split(" ")[1];
				hour = '<p class="marker"><i class="fa fa-fw fa-clock"></i> Hora: ' +  hour + '</p>';
			} else if(this.current.delivery_date) {
				date = this.getDateFormatted(this.current.delivery_date.split(" ")[0]);
				date = '<p class="marker"><i class="fa fa-fw fa-calendar-alt"></i> Data: ' +  date + '</p>';

				hour = this.current.delivery_date.split(" ")[1];
				hour = '<p class="marker"><i class="fa fa-fw fa-clock"></i> Hora: ' +  hour + '</p>';
			} else if(this.current.estimated_start_time) {
				date = '<p class="marker"><i class="fa fa-fw fa-calendar-alt"></i> Data: ' +  this.getDate() + ' (estimativa)</p>';
				hour = '<p class="marker"><i class="fa fa-fw fa-clock"></i> Hora: ' +  this.current.estimated_start_time + ' (estimativa)</p>';
			}

            // Cria o marcador do início
            let markerStart = new L.marker(waypoint.latLng, {
                draggable: false,
                icon: new L.divIcon({
                    className: "customer-div-icon",
                    html: 
                        "<style>" +
                            "#node-marker-start {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: 50% 50% 50% 0; background-color: #669df6; transform: rotate(-45deg); z-index: 2;}" +
                            "#node-marker-start::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                            "#node-marker-start-label {position: absolute; width: 22px; left: 0; right: 0; margin: 6px auto; font-size: 12px; color: #226ed6; text-align: center; z-index: 3;}" +
                        "</style>" +
                        "<div id='node-marker-start'></div><div id='node-marker-start-label'><i class='fa fa-fw fa-truck'></i></div>",
                    iconSize: [30, 30],
                    iconAnchor: [15, 30],
                    popupAnchor: [0, -30],
                }),
            }).on("mouseover", function(e) {
                // Abre o popup quando o mouse passa por cima
                e.target.openPopup();
            }).on("mouseout", function(e) {
                // Fecha o popup quando mouse sai de cima
                e.target.closePopup();
            }).bindPopup(
                '<div class="popup">' +
                    '<h3><b>Último registro do APP no celular</b></h3>' +
					textDriverNameAux +
                    date + 
                    hour +
                '</div>'
            );

			// Adiciona no mapa
			return markerStart;
        },

        /**
		 * Adiciona o marcador do ponto de entrega
		 **/
        createDeliveryMarker: function(waypoint) {
            // Define as veriáveis necessárias
			let status = "";
            let color = "";            
			let textNameAux = "";
            let textAddressAux = "";
			let date = "";
            let hour = "";

			// Identifica o status
            switch(this.current.status) {
                case "in_progress": 
                    status = "A CAMINHO";
                    color = "#005ef7";
                    break;
                case "check_in": 
                    status = "ENTREGANDO";
                    color = "#ffb300";
                    break;
                case "finished": 
                    status = "FINALIZADA";
                    color = "#008000";
                    break;
                case "failed": 
                    status = "NÃO ENTREGUE";
                    color = "#ff0000";
                    break;
                case "untracked": 
                    status = "DESVINCULADA";
                    color = "#eee";
                    break;
            }
            
			// Define o nome do cliente
            if(this.current.customer_name) {
                textNameAux = '<p class="marker"><b>' +  this.current.customer_name + '</b></p>';
            }
			
			// Define o endereço do cliente
            if(this.current.fk_address) {
                textAddressAux =
                    '<p class="marker capitalized"><i class="fa fa-map-marker-alt"></i> Endereço: ' +  this.current.street.toLowerCase() + ", " + this.current.number.toLowerCase() + (this.current.complement ? ", " + this.current.complement.toLowerCase() : "") + " - " + this.current.neighborhood.toLowerCase() + '</p>' +
                    '<p class="marker capitalized"><i class="fa fa-globe-americas"></i> Local: ' +  this.current.city.toLowerCase() + ' - ' + this.current.uf + ', ' + this.current.postal_code + '</p>';
            }

			// Define data e hora de chegada
			if(this.current.estimated_end_time) {
				date = '<p class="marker"><i class="fa fa-fw fa-calendar-alt"></i> Data: ' +  this.getDate() + ' (estimativa)</p>';
				hour = '<p class="marker"><i class="fa fa-fw fa-clock"></i> Hora: ' +  this.current.estimated_end_time + ' (estimativa) </p>';
			}

            // Cria o marcador do início
            let markerDelivery = new L.marker(waypoint.latLng, {
                draggable: false,
                icon: new L.divIcon({
                    className: "customer-div-icon",
                    html: 
                        "<style>" +
                            "#node-marker-delivery {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: 50% 50% 50% 0; background-color: #ea4335; transform: rotate(-45deg); z-index: 2;}" +
                            "#node-marker-delivery::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                            "#node-marker-delivery-label {position: absolute; width: 22px; left: 0; right: 0; margin: 6px auto; font-size: 12px; color: #a60d0d; text-align: center; z-index: 3;}" +
                        "</style>" +
                        "<div id='node-marker-delivery'></div><div id='node-marker-delivery-label'><i class='fa fa-fw fa-box'></i></div>",
                    iconSize: [30, 30],
                    iconAnchor: [15, 30],
                    popupAnchor: [0, -30],
                }),
            }).on("mouseover", function(e) {
                // Abre o popup quando o mouse passa por cima
                e.target.openPopup();
            }).on("mouseout", function(e) {
                // Fecha o popup quando mouse sai de cima
                e.target.closePopup();
            }).bindPopup(
                '<div class="popup">' +
                    '<h3><b style="padding: 0px 5px; background-color: ' + color + '; color: #fff;">ENTREGA ' + status + '</b></h3>' +
                    '<h3><b>Entrega: ' +  this.current.document_number + '</b></h3>' +
                    textNameAux +
                    textAddressAux +
                    date +
					hour +
                '</div>'
            );

			// Adiciona no mapa
			return markerDelivery;
        },

		/**
         * Esconde as div de itinerário original no leaflet
         * @param {boolean} setTime se deve aplicar tempo para remoção das divd de itinerário original no leaflet
         **/ 
        hideControlDivs: function(setTime) {
            // Verifica se é para aplicar tempo
            if(setTime) {
                // Contador de tempo
                setTimeout(() => {
                    // Obtem a lista de divs
                    let controls = $(".leaflet-routing-container");
                    // Verifica se foi encontrado alguma div
                    if(controls.length > 0) {
                        // Oculta todas as divs
                        for(let i = 0; i < controls.length; i++) {
                            controls[i].style.display = "none";
                        }
                    }
                }, 600);
            } else {
                // Obtem a lista de divs
                let controls = $(".leaflet-routing-container");
                // Verifica se foi encontrado alguma div
                if(controls.length > 0) {
                    // Oculta todas as divs
                    for(let i = 0; i < controls.length; i++) {
                        controls[i].style.display = "none";
                    }
                }
            }
        },

		getBone: function(with_bone, without_bone) {
			if ((with_bone != 0) && (without_bone == 0)) return "Sim";
			else if ((with_bone == 0) && (without_bone != 0)) return "Não";
			else return "Não definido";
		},

		getDate: function() {
			var today = new Date();
			var dd = String(today.getDate()).padStart(2, '0');
			var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
			var yyyy = today.getFullYear();

			today = dd + '/' + mm + '/' + yyyy;
			return today;
		},

		getDateFormatted: function(date) {
			return date.split("-").reverse().join("/");
		},

		getDatetimeFormatted: function(datetime) {
			if (datetime) {
				let date = "";
				let time = "";

				let aux = datetime.split("T");
				if (aux.length == 2) {
					date = aux[0].split("-").reverse().join("/");
					time = aux[1].split(".")[0];
				} else {
					aux = datetime.split(" ");
					date = aux[0].split("-").reverse().join("/");
					time = aux[1];
				}
				return date + " " + time;
			} else return "-";
		},

		getDocumentFormatted: function(document) {
			if (document.length > 11) {
				return document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
			} else {
				return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			}
		},

		// Formata o valor em dinheiro
		getMoney: function(money) {
			let moneyAux = money.replace(",", ".").split(".");
			if(moneyAux.length > 1) {
				if (moneyAux[1].length > 1) {
					return "R$ " + moneyAux[0] + "," + moneyAux[1];
				} else {
					return "R$ " + moneyAux[0] + "," + moneyAux[1] + "0";
				}
			} else {
				return "R$ " + moneyAux[0] + ",00";
			}
		},

		getStatus: function(value, check_in) {
			if (value == "in_progress" && check_in) {
				return status["check_in"].status;
			} else {
				return status[value].status;
			}
		},
		
		getStatusColor: function(value, check_in) {
			if (value == "in_progress" && check_in) {
				return status["check_in"].color;
			} else {
				return status[value].color;
			}
		},

		getPaymentMethod: function(data) {
			if (data == '01')  return 'Dinheiro';
			if (data == '02')  return 'Cheque';
			if (data == '03')  return 'Cartão de Crédito';
			if (data == '04')  return 'Cartão de Débito';
			if (data == '05')  return 'Crédito Loja';
			if (data == '10')  return 'Vale Alimentação';
			if (data == '11')  return 'Vale Refeição';
			if (data == '12')  return 'Vale Presente';
			if (data == '13')  return 'Vale Combustível';

			return 'Outros';
		},

		getPostalCodeFormatted: function(postal_code) {
			return postal_code.replace(/^(\d{5})(\d{3})/, "$1-$2");
		},

		getTemperature: function(ambient, chilled, frozen) {
			if ((ambient != 0) && (chilled == 0) && (frozen == 0)) return "Ambiente";
			else if ((ambient == 0) && (chilled != 0) && (frozen == 0)) return "Resfriado";
			else if ((ambient == 0) && (chilled == 0) && (frozen != 0)) return "Congelado";
			else return "Não definida";
		},

		getType: function(type) {
			return type ? "Pedido" : "Nota Fiscal";
		},

		copy: function(str) {
			let copyText = document.createElement("input"); //document.getElementById("myInput");
			copyText.type = "text";
			copyText.value = str;

			document.body.appendChild(copyText);
			copyText.select();
			copyText.setSelectionRange(0, 99999);
			document.execCommand("copy");

			copyText.remove();

			this.$notification.success("Copiado para área de transferência.");
			
		},

        /**
         * Retorna o peso
         * @param {number} weight peso em quilos
         * @return {string} peso em quilos ou toneladas
         */
		getWeight: function(weight) {
            let weightFormated = "";
			
            if(weight < 1000)
                weightFormated = weight.toFixed(2) + " kg";
            else
                weightFormated = (weight / 1000).toFixed(2) + " t";
            
            return weightFormated.replace(".", ",");
        },
	}
}
</script>

<style scoped>
.title-container {
	border: 1px solid #ccc;
	border-radius: 5px;
	margin: 15px 0px;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);
	background-color: #fff;
}

.container-collapse {
	margin-bottom: 15px;
	border: 1px solid #ddd;
	border-radius: 5px;
	padding: 15px;
}

.container-collapse-header {
    cursor: pointer;
}

span.collapse-header-arrow {
    float: right;
}

.container-collapse-body {
    margin-top: 15px;
}

.button-share {
	position: absolute;
	left: 0;
	background: #222;
	color: #fff;
	font-size: 12px;
	padding: 4px 10px;
	border-radius: 4px;
	margin-top: -2px;
}

table { 
	width: 100%;
	border-collapse: collapse;
}

tr:nth-of-type(odd) { 
	background: #eee; 
}

th { 
	background: #3498db; 
	color: white; 
	font-weight: bold; 
}

td, th { 
	padding: 10px; 
	border: 1px solid #ccc; 
	text-align: left; 
	font-size: 14px;
}

.td-map {
	padding: 0px;
}

.checkin-map {
	width: 100%;
	position: relative;
	height: 400px;
}

.timeline-container {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 30px 0px;
}

.timeline {
	position: relative;
	padding: 0px 25px;
	text-align: center;
	color: #bbb;
}

.timeline-active {
	color: #2c3e50;
}

.timeline-step {
	border: 2px solid #bbb;
	border-radius: 5px;
	z-index: 10;
}

.timeline-step-first {
	border: 2px solid #bbb;
	border-radius: 5px;
	z-index: 10;
}

.timeline-step::after {
	content: "";
	display: block;
	position: absolute;
	top: 50%;
	left: -50%;
	width: 100%;
	border-top: 2px dashed #ccc;
	z-index: -1;
}

.timeline-step-active {
	border: 2px solid #2c3e50;
}

.timeline-step-first-active {
	border: 2px solid #2c3e50;
}

.timeline-step-active::after {
	border: 1px solid #2c3e50;
}

.timeline-step-head {
	padding: 5px;
	background-color: #fff;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
}

.timeline-step-head > h1 {
	margin: 0px;
	margin-top: -22px;
}

.timeline-step-head > h1 > span {
	padding: 5px;
	background-color: #fff;
}

.timeline-step-icon {
	padding: 15px;
	border-top: 1px solid #ddd;
	background-color: #eee;
	font-size: 14px;
}

.timeline-step-icon > h1 {
	margin: 0px;
}

.timeline-step-label {
	padding: 5px 15px;
	background-color: #eee;
	font-size: 13px;
}

.timeline-step-datetime {
	padding: 5px 15px 15px;
	background-color: #eee;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
	font-size: 13px;
	height: 54px;
}

.summary-container {
	border: 1px solid #ccc;
	margin-bottom: 30px;
	padding: 30px 15px;
	background-color: #eee;
}

.client-container {
	display: flex;
	align-items: center;
	border: 1px solid #ddd;
	border-radius: 5px;	
	padding: 15px;
	background-color: #fff;
}

.delivery-tab {
	background: #eee;
	border: 1px solid #eee;
	border-bottom: none;
	padding: 10px 15px;
	margin-right: 5px;
	font-weight: bold;
    margin-bottom: -1px;
}

.delivery-tab.enabled {
	background: #fff;
}

.delivery-tab-container {
    border-bottom: 1px solid #eee;
}

.delivery-tab-block {
	display: none;
}
.delivery-tab-block.show {
	display: block;
}
</style>